import { useLogger } from '~/composables/useLogger';
import { isClient } from '~/utils';

export const LAST_SHORTS_URL_STORAGE_KEY = 'lastShortsUrl';

const logger = useLogger('lastShortsUrl');

type StorageOperation = 'clear' | 'read' | 'persist';

function reportStorageError(operation: StorageOperation, error: unknown): void {
	logger.error('Last Shorts URL sessionStorage operation failed', {
		operation,
		storage_key: LAST_SHORTS_URL_STORAGE_KEY,
		error
	});
}

export function clearLastShortsUrlFromStorage(): void {
	if (!isClient()) return;

	try {
		sessionStorage.removeItem(LAST_SHORTS_URL_STORAGE_KEY);
	} catch (error) {
		reportStorageError('clear', error);
	}
}

export function getLastShortsUrlFromStorage(): string | null {
	if (!isClient()) return null;

	try {
		return sessionStorage.getItem(LAST_SHORTS_URL_STORAGE_KEY);
	} catch (error) {
		reportStorageError('read', error);
		return null;
	}
}

export function setLastShortsUrlInStorage(url: string): void {
	if (!isClient() || !url) return;

	try {
		sessionStorage.setItem(LAST_SHORTS_URL_STORAGE_KEY, url);
	} catch (error) {
		reportStorageError('persist', error);
	}
}
